import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ShareForm from '../ShareFormComponent';
import LoginComponent from '../LoginComponent';
import UserProfile from '../UserProfileComponent';
import RegisterComponent from '../RegisterComponent';
import InfoComponent from '../InfoComponent';
import './index.css'

class CustomDialog extends React.Component {

  render() {
    const { handleClose, contentId } = this.props;
    let title, contentComponent;
    switch (contentId) {
      case 'ShareDialog':
        contentComponent = <ShareForm handleClose={handleClose} />;
        title = 'Share form';
        break;
      case 'LoginDialog':
        contentComponent = <LoginComponent handleClose={handleClose} />;
        title = "Login";
        break;
      case 'ProfileDialog':
        contentComponent = <UserProfile />;
        title = "Profile";
        break;
      case 'RegisterDialog':
        contentComponent = <RegisterComponent handleClose={handleClose} />;
        title = "Sign Up";
        break;
      case 'InfoDialog':
        contentComponent = <InfoComponent />;
        title = "About Us";
        break;
      default:
        contentComponent = null;
        title = null;
    }
    return (
      <Dialog
        onClose={handleClose}
        aria-labelledby="DialogTitle"
        id={contentId}
        open={true}
        fullWidth
        fullScreen = {window.innerWidth < '768' ? true :  false}
      >
        <DialogTitle id="DialogTitle" onClose={handleClose}>
          <div className="title-label">
            {title}
          </div>
          <IconButton className="close-button" onClick={handleClose} aria-label="Close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent >
          {contentComponent}
        </DialogContent>
      </Dialog>
    )
  }
}

export default CustomDialog;